import type UserSelectStyles from './types';

const userSelect: UserSelectStyles = {
    userSelectText: {
        userSelect: 'text',
        WebkitUserSelect: 'text',
    },
    userSelectNone: {
        userSelect: 'none',
        WebkitUserSelect: 'none',
    },
};

export default userSelect;
